import ExportIcon from "@mui/icons-material/OutputRounded";
import { Box, Button, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import SearchField from "@entrilia/shared/components/inputs/SearchField";

export type DocumentsFilterValue = "All" | "Viewed" | "NotViewed";

interface Props {
  allCount: number;
  viewedCount: number;
  notViewedCount: number;
  filterValue: DocumentsFilterValue;
  showViewFilter: boolean;
  onFilterChange: (value: DocumentsFilterValue) => void;
  onSearch: (searchTerm: string) => void;
  onExportToCsv: () => void;
  exportDiabled: boolean;
}

const DocumentsViewActions = ({
  allCount,
  viewedCount,
  notViewedCount,
  filterValue,
  showViewFilter,
  onFilterChange,
  onSearch,
  onExportToCsv,
  exportDiabled,
}: Props) => {
  return (
    <Box
      sx={{
        mt: 2,
        mb: 1,
        mr: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: showViewFilter ? "space-between" : "flex-end",
        flexWrap: "wrap",
        rowGap: 1,
      }}
    >
      {showViewFilter && (
        <ToggleButtonGroup
          value={filterValue}
          exclusive
          onChange={(_, value: DocumentsFilterValue) => onFilterChange(value)}
          sx={{ height: "2.25rem" }}
        >
          <ToggleButton value="All" sx={{ gap: 1 }}>
            All <BadgeDetached showZero badgeContent={allCount} color="secondary" />
          </ToggleButton>
          <ToggleButton value="Viewed" sx={{ gap: 1 }}>
            Viewed <BadgeDetached showZero badgeContent={viewedCount} color="secondary" />
          </ToggleButton>
          <ToggleButton value="NotViewed" sx={{ gap: 1 }}>
            Not Viewed <BadgeDetached showZero badgeContent={notViewedCount} color="secondary" />
          </ToggleButton>
        </ToggleButtonGroup>
      )}
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <SearchField onSearch={onSearch} />
        <Button
          color="secondary"
          variant="outlined"
          onClick={onExportToCsv}
          startIcon={<ExportIcon />}
          disabled={exportDiabled}
        >
          Export
        </Button>
      </Stack>
    </Box>
  );
};

export default DocumentsViewActions;
